import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ApiService } from 'src/app/api.service';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  public tokenRecapchaValid = false;

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private apiService: ApiService
  ) { }

  verifyTokenReCaptcha(): Observable<any> {
    return new Observable(observer => {
      this.recaptchaV3Service.execute('importantAction').subscribe((token: string) => {
        this.apiService.verifyTokenValid(token).subscribe(res => {
          observer.next(res);
          observer.complete();
        }, error => observer.error(error));
      }, error => observer.error(error));
    });
  }


}
